var site = site || {};

(function ($) {
  'use strict';

  Drupal.behaviors.bfeed_twitter = {
    attach: function (context, settings) {
      // See bf_massrel.js
      var $socialBlock = $('#social-content--twitter');

      site.bf_massrel.massrel_render(
        $socialBlock.data('massrel-feed'), // feed id
        $socialBlock, // actual element
        tweakData
      );

      // Custom clean our data if need be
      function tweakData(data) {
        // Used to render replacement links
        var linkTemplate = '<a target="_blank" href="{{{el_link_url}}}">{{el_link_text}}</a>';
        // Array of strings to find and links to replace
        var replacements = [];

        // Tweets that contain user_mentions
        site.bf_massrel.tweet_parse_user_mentions = function (element) {
          var userName = '@' + element.screen_name;
          var replacementLinkMarkup = Mustache.render(linkTemplate, {
            el_link_url: 'https://twitter.com/' + encodeURIComponent(element.screen_name),
            el_link_text: userName,
            element: {
              screen_name: 'esteelauderuk'
            }
          });

          replacements.push(
            {
              target: userName,
              string: replacementLinkMarkup
            }
          );
        };

        // Tweets that contain urls
        site.bf_massrel.tweet_parse_urls = function (element) {
          var replacementLinkMarkup = Mustache.render(linkTemplate, {
            el_link_url: element.url,
            el_link_text: element.display_url
          });

          replacements.push(
            {
              target: element.url,
              string: replacementLinkMarkup
            }
          );
        };

        // Tweets that contain media
        site.bf_massrel.tweet_parse_media = function (element) {
          // media urls use the exact same sig as regular urls
          site.bf_massrel.tweet_parse_urls(element);
        };

        // Tweets that contain hashtags
        site.bf_massrel.tweet_parse_hashtags = function (element) {
          var hashTag = '#' + element.text;
          var replacementLinkMarkup = Mustache.render(linkTemplate, {
            el_link_url: 'https://twitter.com/search?q=' + encodeURIComponent(hashTag),
            el_link_text: hashTag
          });

          replacements.push(
            {
              target: hashTag,
              string: replacementLinkMarkup
            }
          );
        };

        // clean up data for the mustache files
        _.map(data, function (tweet) {
          // each "entitiy" (urls, mentions, tags, media) included in the tweet
          _.each(tweet.entities, function (tweetentity, index, list) {
            // call our function dynamically by name
            var callfunc = 'tweet_parse_' + index;

            // Check if function defined for the index of the entity within,
            // call function if so with the elements of within entity
            if (_.isFunction(site.bf_massrel[callfunc]) && !_.isEmpty(tweetentity)) {
              _.each(tweetentity, function (element, index, list) {
                site.bf_massrel[callfunc](element);
              });
            }
          }); // each tweet.entities

          // Replace in tweet body
          _.each(replacements, function (element, index, list) {
            tweet.text = tweet.text.replace(element.target, element.string);
          });

          return tweet;
        }); // map data -> tweet

        // cleanup outgoing data in format php mustache expects
        return { mass_rel: data };
      }
    }
  };
})(jQuery);
